import { put, call, takeLatest, select } from 'redux-saga/effects';
import serialize from 'utils/serialize';
import * as http from 'utils/http';

import config from 'config';

import {
  setLoading,
  setLoadingNext,
  setVehicles,
  setClearVehicles,
  setNextVehiclesLink,
  setTotalVehicles,
  setCurrentVehicle,
} from './duck';

import { getNextVehiclesLink } from './selectors';
import { mapVehicleFiltersForBackend } from './utils';

const VEHICLES_LIST_URL = `${config.API_URL}mercury/vehicles/`;
const VEHICLE_DETAIL_URL = `${config.API_URL}vehicles/`;

// @effect Action
const searchVehicles$ = 'vehicle-section/search$';
const fetchNextVehicles$ = 'vehicle-section/fetchNext$';
const vehicleDetailMounted$ = 'vehicle-section/vehicle-detail-mounted$';

// @effect Creators
export const searchVehicles = (payload) => {
  return {
    type: searchVehicles$,
    payload,
  };
};

export const fetchNextVehicles = (payload) => {
  return {
    type: fetchNextVehicles$,
    payload,
  };
};

export const vehicleDetailMounted = (payload) => {
  return {
    type: vehicleDetailMounted$,
    payload,
  };
};

function* handleSearchVehicles({ payload }) {
  yield put(setClearVehicles());
  yield put(setLoading(true));
  try {
    const backendFilters = yield call(mapVehicleFiltersForBackend, payload);
    const queryStr = yield call(serialize, backendFilters);
    const vehicles = yield call(http.get, `${VEHICLES_LIST_URL}?${queryStr}`);

    yield put(setVehicles(vehicles.results));
    yield put(setTotalVehicles(vehicles.count));
    yield put(setNextVehiclesLink(vehicles.next));
  } catch (e) {
    console.error('Error fetching vehicles: ', e);
  } finally {
    yield put(setLoading(false));
  }
}

function* handleFetchNextVehicles({ payload }) {
  yield put(setLoadingNext(true));
  try {
    const nextVehiclesLink = yield select(getNextVehiclesLink);

    if (!nextVehiclesLink) {
      return;
    }

    const vehicles = yield call(http.get, nextVehiclesLink);
    yield put(setVehicles(vehicles.results));
    yield put(setNextVehiclesLink(vehicles.next));
  } catch (e) {
    console.error('Error fetching vehicles: ', e);
  } finally {
    yield put(setLoadingNext(false));
  }
}

function* handleVehicleDetailMounted({ payload }) {
  try {
    const vehicle = yield call(http.get, `${VEHICLE_DETAIL_URL}${payload}`);
    const carrier = yield call(http.get, vehicle.carrier);
    const vehicleWithCarrier = {
      ...vehicle,
      carrier,
    };
    yield put(setCurrentVehicle(vehicleWithCarrier));
  } catch (e) {
    console.error(e);
  }
}

// Watchers
export function* watchVehicleSection() {
  yield takeLatest(fetchNextVehicles$, handleFetchNextVehicles);
  yield takeLatest(searchVehicles$, handleSearchVehicles);
  yield takeLatest(vehicleDetailMounted$, handleVehicleDetailMounted);
}
